import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { petrol } from '../../styles/mui/colors';

const SearchMapIndicator = () => {
  const [longLoading, setLongLoading] = useState(false);

  useEffect(() => {
    let showAlertTimeout;
    const timeout = setTimeout(() => {
      clearTimeout(showAlertTimeout);
      setLongLoading(true);
      showAlertTimeout = setTimeout(() => {
        setLongLoading(false);
      }, 5000);
    }, 5000);
    return () => {
      clearTimeout(timeout);
      clearTimeout(showAlertTimeout);
    };
  }, []);

  return !longLoading ? (
    <Box
      sx={{
        position: 'absolute',
        top: '15%',
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#fff',
        py: 1,
        px: 2,
        borderRadius: 1,
        zIndex: 1,
      }}
    >
      <CircularProgress size={20} sx={{ color: petrol.main }} />
    </Box>
  ) : (
    <Box
      sx={{
        position: 'absolute',
        top: '15%',
        left: '10%',
        width: '80%',
        borderRadius: 1,
        zIndex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Alert severity="warning" sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: 600,
      }}>
        <FormattedMessage id="SearchPage.mapLoading" />
      </Alert>
    </Box>
  );
};

export default SearchMapIndicator;
